import { render, staticRenderFns } from "./ManageEodNotificationConfig.vue?vue&type=template&id=aaf527f6&"
import script from "./ManageEodNotificationConfig.vue?vue&type=script&lang=js&"
export * from "./ManageEodNotificationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports